var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"dropzone",on:{"dragover":_vm.handleOnDragOver,"drop":_vm.onDrop,"dragenter":_vm.onDragEnterHandler,"dragleave":_vm.onDragLeaveHandler}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }